import { CT_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchMyQuizzes({ commit }, { type, params }) {
  commit(types.FETCH_MY_QUIZZES_REQUEST);
  return http.get(`${CT_API_URL}/users/me/quizzes`, { params })
    .then(res => commit(type, { myQuizzes: res.data, total: res.headers.total }))
    .catch(err => commit(types.FETCH_MY_QUIZZES_FAILURE, err));
}

export function createQuiz({ commit }, data) {
  commit(types.SET_QUIZ_REQUEST);
  return http.post(`${CT_API_URL}/quizzes`, data)
    .then(res => commit(types.SET_QUIZ_SUCCESS, res.data))
    .catch(err => commit(types.SET_QUIZ_FAILURE, err));
}

export function updateQuiz({ commit }, data) {
  commit(types.PUT_QUIZ_REQUEST);
  return http.put(`${CT_API_URL}/quizzes/${data.id}`, data)
    .then(res => commit(types.PUT_QUIZ_SUCCESS, res.data))
    .catch(err => commit(types.PUT_QUIZ_FAILURE, err));
}

export function deleteQuiz({ commit }, id) {
  commit(types.DELETE_QUIZ_REQUEST);
  return http.delete(`${CT_API_URL}/quizzes/${id}`)
    .then(() => commit(types.DELETE_QUIZ_SUCCESS, id))
    .catch(err => commit(types.DELETE_QUIZ_FAILURE, err));
}



// WEBPACK FOOTER //
// ./src/app/my-quizzes/store/actions.js